export default __webpack_public_path__ + "static/media/blueTop.120d060f.jpg";